import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Actions} from "../../core";
import _ from 'lodash';
import "./popup.css"
import Moment from "moment";
import moment from "moment";
import {TimeOut} from "../../core/core/utils/TimeOut";
export const InviterPopup = ({user,onUpdateInvite})=>{
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const popup  = useSelector(state=>state.Store.PopupWindow.modals.inviter)
  const [type,setType] = useState(localStorage.getItem("inviterEventType")?localStorage.getItem("inviterEventType"):"free");
  const [eventId,setEventId] = useState(localStorage.getItem("inviterEventId")?localStorage.getItem("inviterEventId"):-1);
  const nights = useSelector(state=>state.Store.Event);
  const User = useSelector(state=>state.Store.User.data);
  const [index,setIndex]=useState(null)
  const [guests,setGuests] = useState([])
  const [data,setData]=useState(
    localStorage.getItem("guestData")?JSON.parse(localStorage.getItem("guestData")):[{
    "name": "",
    "email": "",
    "pin":"00000000000",
    "quantity": 1,
    "sender": User.fullname,
    "free":"yes"
  }]);
  useEffect(()=>{
    dispatch(Actions.Event.getEvents('inviter'));
    if(user?.data?.role ===11){

      setData([{name:user?.data?.fullname,email:user?.data?.email,pin:user?.data?.id_number,free:'yes',quantity:1,sender:user?.data?.fullname}])
    }
  },[])

  useEffect(()=>{
    localStorage.setItem("guestData",JSON.stringify(data))
  },[data])
  useEffect(()=>{
    localStorage.setItem("inviterEventId",eventId)
  },[eventId])

  useEffect(()=>{
    localStorage.setItem("inviterEventType",type)
  },[type])



  const search = (name)=>{
    TimeOut.clear();
    TimeOut.set(()=>{
      Actions.Event.getGuest(name)
        .then(response=>{
          setGuests(response.status?response.data.data:[])
        })

    },500)
  }

  const guestList = () =>{
      return   guests.length> 0 && <div className={"users-list invitation guest-list"}>
          <table style={{marginTop:0}}>
            <tbody>
            {
              _.map(guests,(v,k)=>{
                return <tr key={k} style={{cursor:'pointer'}} onClick={()=>{
                  let tmp=data;
                  tmp[index]={...tmp[index],...v}
                  setData([...tmp]);
                  setGuests([])
                  setIndex(null)
                }}>
                  <td >
                    <input type={"text"}  placeholder={"Fullname"}  value={v.name}   style={{cursor:'pointer'}}/>
                  </td>
                  <td >
                    <input type={"text"} placeholder={"email"}  value={v.email}   style={{cursor:'pointer'}}/>
                  </td>
                  <td >
                    <input type={"text"}  placeholder={"pin"} value={v.pin}  style={{cursor:'pointer'}} />
                  </td>
                </tr>
              })
            }
            </tbody>
          </table>
      </div>
  }

	return  (
		(popup) ?(
		  <div className="search-sec active inviter">
        <form  onSubmit={async (e) => {
          e.preventDefault();
        }}>
          <div className="log-in-sec" style={{maxWidth:"100%"}}>
            <div className="invites-box">
              <p className="log-un-title" style={{padding:'10px',fontSize:"20px"}}>SEND AN INVITATION</p>
              <select id="night" value={type} onChange={(e)=>setType(e.target.value)} disabled={data.length>1}>
                <option value={"free"}>free</option>
                <option value={"paid"}>paid</option>
              </select>
              <select id="night" value={eventId} onChange={(e)=>setEventId(e.target.value)} disabled={data.length>1}>
                <option>Select night</option>
                { _.map(nights.filter(n=>{
                 // console.log(moment(n.event_start).diff(moment(new Date()).subtract(1,"days")),n)
                  return moment(n.event_start).diff(moment(new Date()).subtract(1,"days"))>0;
                }),(v,k)=><option key={k} value={k}>{v.title} {moment(v.event_start).format("YYYY-MM-DD")} {v?.sub_title}</option>)}
              </select>
              <hr/>
              <div className={"users-list invitation"}>
                <table>
                  <tbody>
                  {
                    _.map(data, (v,k)=>{
                      return (
                        <tr key={k} style={{position:'relative'}}>
                          <td >
                            <input type={"text"} placeholder={"Fullname"} disabled={eventId===-1 || user?.data?.role===11} value={v.name} onChange={(e)=>{
                              let tmp=data;
                              if(k===tmp.length-1){
                                tmp.push(
                                  {
                                    "name": "",
                                    "email": "",
                                    "pin":"00000000000",
                                    "quantity": 1,
                                    "sender": User?.fullname,
                                    "free":"yes"
                                  }
                                )
                                setData([...tmp])
                              }
                              tmp[k]["name"]=e.target.value
                              setData([...tmp]);
                              setIndex(k)
                              search(e.target.value)
                            }}/>
                            { index ===k &&  guestList()}
                          </td>
                          <td>
                            <input type={"text"} placeholder={"Email"}  disabled={eventId===-1 || user?.data?.role===11}  value={v.email} onChange={(e)=>{
                              let tmp=data;
                              if(k===tmp.length-1){
                                tmp.push(
                                  {
                                    "name": "",
                                    "email": "",
                                    "pin":"00000000000",
                                    "quantity": 1,
                                    "sender": User?.fullname,
                                    "free":"yes"
                                  }
                                )
                                setData([...tmp])
                              }
                              tmp[k]["email"]=e.target.value
                              setData([...tmp]);
                            }}/>
                          </td>
                          <td>
                            <input type={"text"} placeholder={"Pin"}  disabled={eventId===-1 || user?.data?.role===11}  value={v.pin} onChange={(e)=>{
                              let tmp=data;
                              if(k===tmp.length-1){
                                tmp.push(
                                  {
                                    "name": "",
                                    "email": "",
                                    "pin":"00000000000",
                                    "quantity": 1,
                                    "sender": User?.fullname,
                                    "free":"yes"
                                  }
                                )
                                setData([...tmp])
                              }
                              tmp[k]["pin"]=e.target.value
                              setData([...tmp]);
                            }}/>
                          </td>
                          <td width={"50"}>
                            <input type={"text"} placeholder={"Quantity"}  value={v.quantity} disabled={true}/>
                          </td>
                          <td>
                            <input type={"text"} placeholder={"Sender"}  disabled={eventId===-1 || user?.data?.role===11} value={v.sender} onChange={(e)=>{
                              let tmp=data;
                              if(k===tmp.length-1){
                                tmp.push(
                                  {
                                    "name": "",
                                    "email": "",
                                    "pin":"00000000000",
                                    "quantity": 1,
                                    "sender": User?.fullname,
                                    "free":"yes"
                                  }
                                )
                                setData([...tmp])
                              }
                              tmp[k]["sender"]=e.target.value
                              setData([...tmp]);
                            }}/>
                          </td>
                          <td width={"50"} align={"center"}  style={{cursor:'pointer'}} onClick={()=>{
                            if(user?.data?.role===11) return;
                            if(data.length >1 ){
                              let tmp=data;
                              tmp.splice(k,1);
                              setData([...tmp]);
                            }
                          }}> <span>-</span></td>
                        </tr>
                      )
                    })
                  }
                  </tbody>
                </table>
              </div>

              <span className={"sendBtn"} onClick={async () => {
                if(loader){
                  return;
                }
                if (eventId !== -1 && data.length > 0) {

                  setLoader(true)

                  const response = await dispatch(Actions.Inviter.sendInvites(type,{
                    type:type,
                    event: {
                      "id": nights[eventId]["id"],
                      "title": nights[eventId]["title"],
                      "timestamp": Moment(nights[eventId]["event_start"]).format("DD MMM / YYYY hh:mm").toString(),
                      "price": nights[eventId]["price"]
                    },
                    data: data.filter(value => value.name && value.email && value.sender)
                  }))
                  setLoader(false)
                  if(response.status){
                    if(user?.data?.role !==11) {
                      setData([{
                        "name": "",
                        "email": "",
                        "pin":"00000000000",
                        "quantity": 1,
                        "sender": User?.fullname,
                        "free":"yes"
                      }])
                    }

                    localStorage.removeItem("guestData")
                    setEventId(-1)
                    dispatch({type: 'POPUP_WINDOW', payload:false})
                    onUpdateInvite();
                  }else {
                    alert(response.data.error)
                  }
                } else {
                  alert("Enter correct information")
                }


              }}>{ loader?'PLEASE WAIT...':'SEND'}</span>
            </div>
          </div>
        </form>
		 </div>):null
	)
}
